import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthStorage } from "../auth/storage/auth-storage";

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authStorage = inject(AuthStorage);

  authStorage.loadFromStorage();

  if (authStorage.user()) {
    return true;
  }
  return router.createUrlTree(["/login"]);
};
